import { useEffect, useRef } from 'react';

function useIsMountedRef() {
  /* Fix for React state update on an unmounted component:
	"Warning: Can’t perform a React state update on an unmounted component.
	This is a no-op, but it indicates a memory leak in your application. To fix,
	cancel all subscriptions and asynchronous tasks in a useEffect cleanup function."
	
	https://www.debuggr.io/react-update-unmounted-component/
	*/
  const isMountedRef = useRef(null);
  useEffect(() => {
    isMountedRef.current = true;
    return () => (isMountedRef.current = false);
  });
  return isMountedRef;
}

export default useIsMountedRef;
